/**
 * Platform-agnostic storage abstraction.
 *
 * Defaults to localStorage (web). Mobile (or any other platform) can call
 * setStorageImpl(AsyncStorage) before the Redux store is created to swap in
 * an async-compatible implementation.
 *
 * The interface matches a synchronous subset that works for both platforms:
 *   storage.getItem(key)        → string | null  (may return a Promise on mobile)
 *   storage.setItem(key, value) → void           (may return a Promise on mobile)
 */

const localStorageImpl = {
  getItem: (key) => {
    try {
      return typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      if (typeof localStorage !== 'undefined') localStorage.setItem(key, value);
    } catch {
      // ignore
    }
  },
};

let storageImpl = localStorageImpl;

/**
 * Override the storage implementation (e.g. AsyncStorage on React Native).
 * Call this before dispatching any actions that use storage.
 */
export function setStorageImpl(impl) {
  storageImpl = impl;
}

export const storage = {
  getItem: (key) => storageImpl.getItem(key),
  setItem: (key, value) => storageImpl.setItem(key, value),
};
